import { Stack } from '@mantine/core';
import FinalCta from '@/components/landing/FinalCta';
import HeroSection from '@/components/landing/HeroSection';
import HowItWorks from '@/components/landing/HowItWorks';
import MobileAppSection from '@/components/landing/MobileAppSection';
import Opportunities from '@/components/landing/Opportunities';
import ServiceCards from '@/components/landing/ServiceCards';

// Публичный лендинг. Тонкая страница-композиция секций.
export default function Landing() {
  return (
    <Stack gap={0}>
      <HeroSection />
      <HowItWorks />
      <ServiceCards />
      <Opportunities />
      <MobileAppSection />
      <FinalCta />
    </Stack>
  );
}
